import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {appendSupportChatMessage, setSupportChatSessionId} from "../../../actions";
import ChatWindow from "../chat_window";
import NewChatWindow from "./new_chat_window";
import SupportChatSessions from "./support_chat_sessions";

export default function ClientSupportChat({imageMap}) {
  const dispatch = useDispatch()

  if (!imageMap) {
    return <div>Missing image map.</div>
  }

  const [createNewChat, setCreateNewChat] = useState(false)
  const [isChatEnabled, setIsChatEnabled] = useState(false)

  const tagOwner = useSelector((state) => state.tagOwner)
  // const accountOrganization = imageMap.account_organization
  const accountOrganization = useSelector((state) => state.accountOrganizations?.find((accountOrganization) => accountOrganization.id === imageMap.account_organization_id))
  const isAccountOrganizationOnlineUrl = useSelector((state) => state.isAccountOrganizationOnlineUrl);
  const clientSendSupportChatMessageUrl = useSelector((state) => state.clientSendSupportChatMessageUrl);
  const supportChatSessionId = useSelector((state) => state.supportChatSessionId)
  const supportChatSessions = useSelector((state) => state.supportChatSessions.filter((supportChatSession) => supportChatSession.tag_owner_id === tagOwner?.id && supportChatSession.account_organization_id === accountOrganization?.id))
  const supportChatSession = supportChatSessions.find((supportChatSession) => supportChatSession.id === supportChatSessionId)
  const translations = useSelector(state => (state.htmlContents || []).find(hc => hc.identifier == "support_chat.translations")?.json || {})

  // let accountLongestAgoTillNotOnline = moment().subtract(60*5, 'seconds')
  // const isChatEnabled = accountOrganization?.is_online || false // accountOrganization?.last_active_time && moment(accountOrganization.last_active_time).isAfter(accountLongestAgoTillNotOnline)

  const checkAccountOrganizationOnlineStatus = () => {
    if (accountOrganization && isAccountOrganizationOnlineUrl) {
      axios({
        method: "post",
        url: isAccountOrganizationOnlineUrl.replace("@@account_organization_id@@", accountOrganization.id),
        data: {}
      }).then(
        (data) => {
          if (data.data.status === "OK") {
            setIsChatEnabled(data.data.is_online)
          } else {
            setIsChatEnabled(false)
          }
        },
        (error) => {
          console.error(error)
          alert(error || "A error occurred while updating online status online.")
        }
      );
    }
  }

  useEffect(() => {
    checkAccountOrganizationOnlineStatus()

    let count = 0
    const interval = setInterval(() => {
      if (count <= 15) {
        checkAccountOrganizationOnlineStatus()
        count++
      }
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [])

  const allComplete = supportChatSessions.every((supportChatSession) => supportChatSession.complete)
  const showNewChatSessionContainer = !createNewChat && allComplete && !supportChatSessionId

  let chatMessageContainer = null

  const setSelectedSupportChatSessionId = (newSupportChatSessionId) => {
    dispatch(setSupportChatSessionId(newSupportChatSessionId))
  }

  if (supportChatSession) {
    chatMessageContainer = <>
      <div className="support-chat-nav-bar shadow-sm">
        <div className="support-chat-nav-item" onClick={() => {
          dispatch(setSupportChatSessionId(null))
        }}>
          <i className="fa fa-chevron-left"/>
          {" "}
          {translations?.go_back || "Go Back"}
        </div>
      </div>
      <ChatWindow
        isTagOwner={true}
        translations={translations}
        additionalData={{image_map_id: imageMap.id}}
        sendMessageUrl={clientSendSupportChatMessageUrl}
        supportChatSession={supportChatSession}
        onSuccessfullySent={(support_chat_message) => {
          dispatch(appendSupportChatMessage(support_chat_message))
        }}/>
      {supportChatSession && supportChatSession.complete ? <p className="text-center">
        <strong>
          {translations?.already_closed || "This chat is already closed!"}
          <br/>
          {<>
            {translations?.continue_chat_part_1 || "If you want to continue to chat, you have to start a"}
            {" "}
            <a href={""} onClick={(event) => {
              dispatch(setSupportChatSessionId(null))
              setCreateNewChat(true)
              event.preventDefault()
              event.stopPropagation()
            }}>
              {translations?.continue_chat_part_2 || "new chat."}
            </a>
          </>}
        </strong>
      </p> : null}
    </>
  } else if (createNewChat) {
    chatMessageContainer = <NewChatWindow imageMap={imageMap} onSuccessfullySent={() => {
      setCreateNewChat(false)
    }}/>
  } else if (supportChatSessions && supportChatSessions.length) {
    chatMessageContainer = <SupportChatSessions supportChatSessions={supportChatSessions}
                                                setSelectedSupportChatSessionId={setSelectedSupportChatSessionId}/>
  }


  return <>
    {!isChatEnabled && !createNewChat && !supportChatSession && <div className={"row"}>
      <div className="col-12 text-center pb-4">
        {accountOrganization?.support_chat_not_available_text ?
          <div dangerouslySetInnerHTML={{__html: accountOrganization?.support_chat_not_available_text}}/> : <div>
            <h4>Not Available</h4>
            <p className={"p-2"}>
              We are currently not online. Your message will be forwarded to us and we will get back to you shortly.
            </p>
          </div>}
      </div>
    </div>}

    {showNewChatSessionContainer ? <>
      <div className={"row"}>
        <div className="col-12 text-center pb-4">
          {isChatEnabled && <>
            {accountOrganization?.support_chat_available_text ?
              <div dangerouslySetInnerHTML={{__html: accountOrganization?.support_chat_available_text}}/> : <div>
                <p className="p-3">
                  Write your message below and start chatting with us.
                </p>
              </div>}
          </>}
          <button
            type="button"
            className="btn-ueg btn-ueg-styled"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setCreateNewChat(true)
            }}>
            {isChatEnabled ? translations?.start_chat || "Start Chat" : translations?.leave_message || "Leave a message" }

          </button>
        </div>
      </div>
    </> : null}

    {chatMessageContainer}
  </>


  // return <div className="modal preview-modal" role="dialog" tabIndex="-1"
  //             onClick={(event) => {
  //               onModalClose ? onModalClose() : alert("No modal close action available.")
  //             }}>
  //   <div className="modal-dialog" role="document">
  //     <div className="modal-content" onClick={(event) => {
  //       event.stopPropagation()
  //     }}>
  //       <div className="modal-header">
  //         <div className="modal-title">
  //           {data.title}
  //         </div>
  //         <button
  //           type="button"
  //           className="close"
  //           data-dismiss="modal"
  //           aria-label="Close"
  //           onClick={() => {
  //             onModalClose ? onModalClose() : alert("No modal close action available.")
  //           }}>
  //           <span aria-hidden="true">&times;</span>
  //         </button>
  //       </div>
  //       <div className="modal-body p-0 styled-scrollbar"
  //            style={supportChatSession ? {} : {maxHeight: "40vh", overflowY: "auto", overflowX: "hidden"}}>
  //
  //
  //       </div>
  //     </div>
  //   </div>
  // </div>;
}